import React from 'react'
import styled from 'styled-components'
import { Link } from 'react-router-dom'

import { Title } from '../../styled/options-container'

import { useRecents } from '../hooks/use-recents-hook'

const FlexHeader = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: left;
  align-items: center;
`
const RecentItem = styled.div`
  display: inline-block;
  max-width: 215px;
  overflow: hidden;
  margin: 0px;

  a {
    display: inline-block;
    width: 300px;
    overflow: hidden;
    margin-left: 0px!important;
    padding-left: 0px!important;
  }
`

const Recents = ({ closeMenuFn, path = 'songs', title }) => {
  const data = useRecents(path)
  return (
    <div>
      <FlexHeader>
        <div><Title>{title}</Title></div>
      </FlexHeader>
      <div>
        {data.map(recent => {
          return <RecentItem key={`recent-${path}-${recent.id}`}><Link onClick={closeMenuFn} to={`/${path}/${recent.id}`}>{recent.display}</Link></RecentItem>
        })}
      </div>
    </div>
  )
}

export default Recents
